import { observer } from 'mobx-react-lite';
import {
  CirclePicture,
  ContentBlock,
  FlexContainer,
  Icon,
  IconTooltip,
  Txt,
} from '../index';
import styles from './UserInfoBlock.module.scss';

/**
 * UserInfoBlock
 *
 * @return {JSX.Element}
 */
const UserInfoBlock = ({ dataState, onClick }) => {
  const { data } = dataState;
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <ContentBlock alignCenter gap onClick={onClick}>
      <CirclePicture fullText={`${data.firstName} ${data.lastName}`} />
      <FlexContainer column>
        <Txt>{data.fullName}</Txt>
        <FlexContainer
          gapHalf
          alignCenter
          className={styles.TenantContactBlock}
        >
          <a
            href={`mailto:${data.emailAddress}`}
            target="_blank"
            rel="noreferrer"
            onClick={stopPropagation}
          >
            <Icon name="envelope" />
          </a>
          <a
            href={`tel:${data.mobileNumber}`}
            target="_blank"
            rel="noreferrer"
            onClick={stopPropagation}
          >
            <Icon name="phone" />
          </a>
          {data.hasGuarantor ? (
            <IconTooltip name="secure">
              <ContentBlock alignCenter gap flex>
                <CirclePicture
                  fullText={`${data.guarantor.firstName} ${data.guarantor.lastName}`}
                />
                <FlexContainer column>
                  <Txt noWrap>{data.guarantor.fullName}</Txt>
                  <FlexContainer
                    gapHalf
                    alignCenter
                    className={styles.TenantContactBlock}
                  >
                    <a
                      onClick={stopPropagation}
                      href={`mailto:${data.guarantor.emailAddress}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Icon name="envelope" />
                    </a>
                    <a
                      href={`tel:${data.guarantor.mobileNumber}`}
                      target="_blank"
                      rel="noreferrer"
                      onClick={stopPropagation}
                    >
                      <Icon name="phone" />
                    </a>
                  </FlexContainer>
                </FlexContainer>
              </ContentBlock>
            </IconTooltip>
          ) : null}
        </FlexContainer>
      </FlexContainer>
    </ContentBlock>
  );
};

UserInfoBlock.displayName = 'UserInfoBlock';

export default observer(UserInfoBlock);
